import { render, staticRenderFns } from "./subscription-status-tag.vue?vue&type=template&id=70680038"
import script from "./subscription-status-tag.vue?vue&type=script&lang=js"
export * from "./subscription-status-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports